import React from 'react'
import { Typography, Grid, Container } from '@material-ui/core';
import '../EndOfFlowPage.scss'

const FaliurePage = () => {
    return (
            <div>
                <Typography class="congrats-main-title">We are <br /> <span className='super-light-blue margin-bottom-large'> almost there!</span></Typography>
                <Typography variant='body1' className='white bold margin-bottom-medium'>Thank you for finishing your application. <br/>
                 We are currently processing the information and preparing your quote. <br/>
                 Once the quote is ready for you to review we will reach out to you and <br/> you'll be able to review it here.</Typography>
                </div>
    )

}

export default FaliurePage